import styled from 'styled-components';

export const SectionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SectionTitle = styled.span`
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.75rem;
  color: #252c34;
`;
